import { createFileRoute } from '@tanstack/react-router';
import { PostDetailPage } from '../../../../features/community-hub/components/post-detail-page';

export const Route = createFileRoute('/_protected/community-hub/posts/$id')({
  component: PostDetailPage,
});
